import { Controller, useFormContext } from "react-hook-form";
import { makeStyles, TextField } from "@material-ui/core";
import { ErrorMessage } from "@hookform/error-message";

import { IProps } from "../../types/types";
import styles from "../../styles/SelectField.module.scss";

const selectStyles = makeStyles(() => ({
  root: {
    "& .MuiFormLabel-root": {
      fontSize: "1.4rem",
      lineHeight: "0",
      fontFamily: "Montserrat",
      fontWeight: 500,
    },
    "& .MuiInputBase-input": { width: "94%", fontSize: "1.5rem" },
  },
}));

export const SelectField = (props: IProps) => {
  const { name, label, required, component } = props;
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();
  const stylesMui = selectStyles();
  const errorMessage = required && "Este campo debe ser completado";

  return (
    <div className={styles.formItem}>
      <div className={styles.wrapper}>
        <Controller
          control={control}
          {...register(name, {
            required: errorMessage,
          })}
          name={name}
          defaultValue=""
          render={({ field: { onChange, name, value, ref } }) => (
            <TextField
              id="standard-select-currency-native"
              ref={ref}
              select
              name={name}
              label={label}
              value={value}
              required={required}
              onChange={onChange}
              className={stylesMui.root}
              variant="standard"
              SelectProps={{
                native: true,
              }}
            >
              <option selected disabled value=""></option>
              {component.options?.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </TextField>
          )}
        />
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <span className={styles.form__error}>{message}</span>
          )}
        />
      </div>
    </div>
  );
};
